import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Botao } from '../../../components/Botao';
import { CorpoDaPagina } from '../../../components/CorpoDaPagina';
import { Input } from '../../../components/Input';
import { Modal } from '../../../components/Modal';
import { Seletor } from '../../../components/Seletor';
import { Tabela } from '../../../components/Tabela';
import { EmailStore } from '../../../stores/EmailStore';
import {
  InputsDistribuidos,
  ConteinerTabela,
  Formulario,
  InputContainer,
  ConteinerModal,
} from './styles';

function ListagemAdministrativa() {
  const [checkBoxSelecionados, atribuirCheckBoxSelecionados] = useState([]);
  const [emailSelecionado, atribuirEmailSelecionado] = useState([]);
  const [filtros, atribuirFiltros] = useState({});
  const [modalAberto, atribuirModalAberto] = useState(false);
  const [parametros, atribuirParametros] = useState({
    pagina: 1,
    registroPorPagina: 30,
    ordenarDecrescente: false,
  });
  const [selecaoMultipla, atribuirSelecaoMultipla] = useState(false);
  const [solicitacoes, atribuirSolicitacoes] = useState([]);
  const [totalPaginas, atribuirTotalPaginas] = useState(0);
  const [totalRegistros, atribuirTotalRegistros] = useState(0);

  const historico = useHistory();

  const formRef = useRef(null);

  const aprovarSolicitacoes = async (listaDeIds) => {
    const response = await EmailStore.aprovarSolicitacao(listaDeIds);

    if (response.status === 200) {
      if (listaDeIds.length > 1) {
        toast.success('Análise finalizada. E-mails aprovados com sucesso!');
      } else {
        toast.success('Análise finalizada. E-mail aprovado com sucesso!');
      }
      obterSolicitacoes();
    } else if (response.status >= 400 && response.status < 500) toast.error(response.data);

    atribuirModalAberto(false);
  };

  const controlarModal = () => {
    atribuirModalAberto(!modalAberto);
  };

  const enviar = useCallback((data) => {
    atribuirFiltros(data);
  }, []);

  const mudarPagina = (param) => {
    atribuirParametros({ ...parametros, pagina: param });
  };

  const limparFiltros = () => {
    formRef.current.reset();
    atribuirFiltros({});
  };

  const obterSolicitacoes = async () => {
    const response = await EmailStore.obterTodasSolicitacoes({ ...parametros, ...filtros });

    if (response.status === 200) {
      atribuirSolicitacoes(response.data.solicitacoes);
      atribuirTotalPaginas(response.data.totalDePaginas);
      atribuirTotalRegistros(response.data.totalDeRegistros);
    } else if (response.status >= 400 && response.status < 500) toast.error(response.data.mensagem);
    else toast.error(response.data.message);
  };

  const obterDadosDaLinha = async (item) => {
    const response = await EmailStore.obterPorListaDeId([item.solicitacaoId]);

    atribuirEmailSelecionado(response.data);

    atribuirModalAberto(true);
  };

  const obterDadosDosSelecionados = async () => {
    const response = await EmailStore.obterPorListaDeId(checkBoxSelecionados);

    atribuirEmailSelecionado(response.data);
    atribuirModalAberto(true);
  };

  useEffect(() => {
    sessionStorage.setItem('checkBoxSelecionados', JSON.stringify(checkBoxSelecionados));

    if (checkBoxSelecionados.length > 1) {
      atribuirSelecaoMultipla(true);
    } else {
      atribuirSelecaoMultipla(false);
    }
  }, [checkBoxSelecionados]);

  useEffect(() => {
    const selecoesSalvas = sessionStorage.getItem('checkBoxSelecionados');
    if (selecoesSalvas) {
      atribuirCheckBoxSelecionados(JSON.parse(selecoesSalvas));
    }
  }, []);

  useEffect(() => {
    obterSolicitacoes();
  }, [filtros, parametros]);

  const acoesRegistroTabela = [
    {
      texto: '',
      icone: 'FaPen',
      cor: 'primary',
      tooltip: 'Analisar',
      aoClicar: obterDadosDaLinha,
      retornarObjeto: true,
    },
  ];

  const acoesModal = (
    <>
      <Botao
        texto={emailSelecionado.length > 1 ? 'Reprovar todos' : 'Reprovar'}
        aoClicar={() => {
          const listaDeIds = emailSelecionado.map((obj) => obj.id).join('&');
          historico.push(`/email/recusar/${listaDeIds}`);
        }}
        cor='danger_darker'
      />
      <Botao
        texto={emailSelecionado.length > 1 ? 'Aprovar todos' : 'Aprovar'}
        aoClicar={() => {
          const listaDeIds = emailSelecionado.map((obj) => obj.id);
          aprovarSolicitacoes(listaDeIds);
        }}
        cor='success_darker'
      />
    </>
  );

  const colunasTabela = [
    {
      nome: 'Instituição',
      propriedade: 'instituicaoEnsinoNome',
      ordenavel: true,
      largura: '35%',
      filtrado: true,
    },
    {
      nome: 'Email',
      propriedade: 'email',
      largura: '35%',
      filtrado: true,
    },
    {
      nome: 'Situação',
      propriedade: 'status',
      largura: '15%',
      filtrado: true,
    },
  ];

  return (
    <CorpoDaPagina titulo={'Solicitações de cadastro de e-mail'}>
      <Formulario ref={formRef} onSubmit={enviar}>
        <InputContainer>
          <Input titulo='Instituição' nome='instituicao' placeholder={'Informe a instituição'} />
          <Input titulo='Email' nome='email' placeholder={'Informe o e-mail'} />
          <Seletor
            nome='status'
            titulo='Situação'
            opcoes={[
              { label: 'Todas', value: '' },
              { label: 'Aguardando análise', value: 'Aguardando análise' },
              { label: 'E-mail aprovado', value: 'E-mail aprovado' },
              { label: 'E-mail reprovado', value: 'E-mail reprovado' },
            ]}
          />
        </InputContainer>

        <InputContainer>
          <Botao
            texto={'Analisar selecionados'}
            aoClicar={() => {
              obterDadosDosSelecionados();
            }}
            outlined
            desabilitado={checkBoxSelecionados.length < 2}
          />
          <InputsDistribuidos>
            <Botao texto='Limpar filtros' cor='danger' outlined aoClicar={() => limparFiltros()} />
            <Botao texto='Filtrar' tipo='submit' />
          </InputsDistribuidos>
        </InputContainer>
      </Formulario>

      <ConteinerTabela>
        <Tabela
          colunas={colunasTabela}
          acoesDoRegistro={acoesRegistroTabela}
          dados={solicitacoes.map((solicitacao) => ({
            ...solicitacao,
            disabled:
              solicitacao.status === 'E-mail aprovado' || solicitacao.status === 'E-mail reprovado',
          }))}
          aoMudarDePagina={mudarPagina}
          totalDePaginas={totalPaginas}
          totalDeRegistros={totalRegistros}
          registrosPorPagina={
            parametros.registroPorPagina === 0 ? 30 : parametros.registroPorPagina
          }
          aoOrdenar={(column, desc) =>
            atribuirParametros({ ...parametros, ordenarPor: column, ordenarDecrescente: desc })
          }
          ordenacaoDecresente={parametros.ordenarDecrescente}
          ordenarPor={parametros.ordenarPor}
          chaveId='solicitacaoId'
          selecionavel
          aoSelecionar={atribuirCheckBoxSelecionados}
          selecaoMultipla={selecaoMultipla}
        ></Tabela>
      </ConteinerTabela>

      {modalAberto && (
        <Modal
          titulo='Análise de e-mail vinculado'
          acoes={acoesModal}
          controleAberturaModal={controlarModal}
        >
          <ConteinerModal>
            {emailSelecionado.map((instituicao) => {
              return (
                <ul key={instituicao.instituicaoDeEnsinoId}>
                  <li>
                    Você está analisando como email institucional
                    <span id='destaqueModal'>&quot;{instituicao.email}&quot;</span> para a
                    instituição
                    <span id='destaqueModal'>
                      &quot;{instituicao.instituicaoDeEnsinoNome}&quot;
                    </span>
                  </li>
                </ul>
              );
            })}
          </ConteinerModal>
        </Modal>
      )}
    </CorpoDaPagina>
  );
}

export default ListagemAdministrativa;
